import React, { useState } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { Expand } from "@sparefoot/react-commons";
import { Chevron } from "components/core/Icons";
import { Button } from "components/core/Button";
import PSPMarkdownContent from "components/molecules/PSPMarkdown/PSPMarkdownContent";
import "./FAQAccordionItem.scss";
import { H3 } from "components/core/Typography";

const FAQAccordionItem = ({ question, answer, defaultOpen = false }) => {
	const [isExpanded, setIsExpanded] = useState(defaultOpen);

	const handleToggle = () => setIsExpanded((prev) => !prev);

	return (
		<div
			className={classnames("faq-accordion-item", {
				"faq-accordion-item--expanded": isExpanded
			})}
		>
			<Button
				className="faq-accordion-item__header"
				onClick={handleToggle}
				aria-expanded={isExpanded}
				type="button"
			>
				<H3
					className="faq-accordion-item__question"
					last
				>
					{question}
				</H3>
				<Chevron
					className="faq-accordion-item__icon"
					size="medlarge"
					rotate={isExpanded ? "up" : "down"}
				/>
			</Button>
			<Expand
				expanded={isExpanded}
				autoHeight
			>
				<div className="faq-accordion-item__content">
					<PSPMarkdownContent
						content={answer}
						className="faq-accordion-item__answer"
						additionalProps={{
							paragraph: {
								size: "standard",
								color: "charcoal",
								weight: "regular"
							}
						}}
					/>
				</div>
			</Expand>
		</div>
	);
};

FAQAccordionItem.propTypes = {
	question: PropTypes.string.isRequired,
	answer: PropTypes.string.isRequired,
	defaultOpen: PropTypes.bool
};

export default FAQAccordionItem;
